export const b64DecodeUnicode = (str) => {
    try {
        return decodeURIComponent(
            atob(str).split("").map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)).join("")
        );
    } catch (error){
        return str;
    }
};

export const b64EncodeUnicode = (str) => btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
        function toSolidBytes(match, p1) {
            return String.fromCharCode("0x" + p1);
        })
);


export const convertDataToJSON = (data) => {
    if (!data) {
        return "{}";
    }

    if (typeof data === "string") {
        return data;
    }

    return (
        JSON.stringify(data || undefined, null, 4) || "{}"
    );
};

export const b64DecodeAndFormatJson = (data) => {
    if (typeof data === "string" && data.indexOf("&quot") !== -1){
        data = String(data).replaceAll("&quot;", "\"");
    }

    if (typeof data === "string") {
        const string = b64DecodeUnicode(data);

        try {
            const object = JSON.parse(string);

            return convertDataToJSON(object);
        } catch (error) {
            console.error(error);

            return string;
        }
    }

    return "{}";
};

export const getPercent = (all, inQueue) => {
    if(all === inQueue || inQueue === 0){
        return 100;
    }

    return Math.floor(inQueue * 100 / all);
};
